import React from 'react';

import { BottomSectionProps } from '@/modules/common/components/templates/data-reconciliation/components/parts/data-reconciliation-bottom-section';
import { EntityReconciliationStep } from '@/modules/data-reconciliation/pages/entity-reconciliation-step';
import { useProjectsReconciliationConfig } from '@/modules/onboarding/projects-setup/config/projects-reconciliation-config';

export interface ProjectsReconciliationStepProps {
  isInfiniteSizeTable?: boolean;
  onClickNext: () => void;
  bottomSection: (props: BottomSectionProps) => React.ReactNode;
  /** Reports dirty state changes (true when there are unsaved form modifications) */
  onDirtyChange?: (isDirty: boolean) => void;
}

export const ProjectsReconciliationStep: React.FC<ProjectsReconciliationStepProps> = ({
  onClickNext,
  bottomSection,
  isInfiniteSizeTable,
  onDirtyChange,
}) => {
  const config = useProjectsReconciliationConfig();

  return (
    <EntityReconciliationStep
      config={config}
      onClickNext={onClickNext}
      bottomSection={bottomSection}
      isInfiniteSizeTable={isInfiniteSizeTable}
      onDirtyChange={onDirtyChange}
    />
  );
};
